import styled from 'styled-components';

export const Spotlight = styled.div.attrs({
  className: 'Spotlight__Wrapper',
})``;

export const SpotlightDesktopStyles = () => ({
  spotlight: {
    borderRadius: 6,
    maxWidth: '4.4rem',
    maxHeight: '2.2rem',
  },
});

export const SpotlightStyles = ({ step }) => ({
  spotlight: {
    borderRadius: 50,
    transition: 'transform 2s',
  },
  beacon: {
    display: 'none',
    position: 'absolute',
    top: 20,
    left: 10,
  },
  buttonBase: {
    backgroundColor: 'transparent',
    borderRadius: 4,
    cursor: 'pointer',
    lineHeight: 1,
    padding: '4.375rem',
    WebkitAppearance: 'none',
  },
  buttonClose: {
    display: 'none',
  },
  buttonNext: {
    fontSize: '.9375rem',
    color: '#fff',
    width: step === 4 ? 'calc(100% - 2.5rem)' : '45%',
    height: '2.5rem',
    backgroundColor: '#00205B',
    borderRadius: 4,
    position: 'absolute',
    left: '1.25rem',
    bottom: '1.75rem',
  },
  buttonSkip: {
    fontSize: '.875rem',
    color: '#00205B',
    textAlign: 'right',
    position: 'absolute',
    right: '1.25rem',
    bottom: '2rem',
  },
  portal: {
    width: '100%',
    height: '100%',
    margin: '1.25rem',
  },
  tooltip: {
    placement: 'center',
    padding: '1.25rem',
    minWidth: 'calc(20rem - 1.125rem)',
    minHeight: '13rem',
    maxWidth: 'calc(100vh/13.75rem)',
    maxHeight: 'calc(100vw/16.875rem)',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  tooltipTitle: {
    fontSize: '1.875rem',
    lineHeight: '2.125rem',
    color: '#00205B',
    margin: '0 0 0.625rem',
  },
  tooltipContent: {
    fontSize: '1.125rem',
    letterSpacing: '0.05px',
    color: '#333333',
    padding: 0,
    margin: '.5rem 0 4rem',
  },
});
